import { apiGet, API_URI } from './index';

const core = {
    getBrandAssociation: async () => {
        const data = await apiGet(`${API_URI}/api/core/ba/all`);
        return data;
    },
    getContentClassification: async () => {
        const data = await apiGet(`${API_URI}/api/core/cc/all`);
        return data;
    },
    getFavourability: async () => {
        const data = await apiGet(`${API_URI}/api/core/favourability/all`);
        return data;
    },
    getStream: async () => {
        const data = await apiGet(`${API_URI}/api/core/stream/all`);
        return data;
    },
    getCoreOptionsAll: async () => {
        const data = await apiGet(`${API_URI}/api/core/all`);
        return data;
    }
}

export default core;